import { atom } from "recoil";

export const industriesAtom = atom({
  key: "industriesAtom",
  default: [],
});

export const companiesAtom = atom({
  key: "companiesAtom",
  default: false,
});

export const offersAtom = atom({
  key: "offersAtom",
  default: [],
});

export const brochuresAtom = atom({
  key: "brochuresAtom",
  default: false,
});
export const sliderBrochuresAtom = atom({
  key: "sliderBrochuresAtom",
  default: false,
});
export const toggleSliderAtom = atom({
  key: "toggleSliderAtom",
  default: false,
});
export const similarOffersAtom = atom({
  key: "similarOffersAtom",
  default: false,
});
export const nextOfferAtom = atom({
  key: "nextOfferAtom",
  default: false,
});
export const slideLoaderAtom = atom({
  key: "slideLoaderAtom",
  default: false,
});
export const userLocationAtom = atom({
  key: "userLocationAtom",
  default: false,
});
export const UUIDAtom = atom({
  key: "UUIDAtom",
  default: false,
});
